module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#edit",
      toString: function () {
        return this.url;
      }
    }